import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { setItem } from '../../Utils/localStorageUtils';
import { useMyContext } from '../Provider/CommonProvider';

const PrivateRoute = ({ children }) => {

  const DEPLOYMENT_ID = process.env.REACT_APP_Baseurl_DEPLOYMENT_ID

  const { fetchOrganisationDetails, isExpired: isExpiredFromContext } = useMyContext();
  const [orgDetails, setOrgdetails] = useState(null);

  const isLoggedIn = !!localStorage.getItem("access_token");
  const location = useLocation();

  useEffect(() => {
    const fetchRequest = async () => {
      try {
        const storedData = await fetchOrganisationDetails(DEPLOYMENT_ID);
        setOrgdetails(storedData?.data);
      } catch (error) {
        console.error("Error fetching organisation details:", error);
      }
    };

    if (isLoggedIn) {
      fetchRequest();
    }
  }, [isLoggedIn, fetchOrganisationDetails]);

  setItem('location', window.location.pathname);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const isExpired = isExpiredFromContext();

  if (isExpired && location.pathname !== "/" && location.pathname !== "/purchase-subscription") {
    return <Navigate to="/" replace />;
  }

  return children;
};
export default PrivateRoute;
